import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { captureException } from '@sentry/browser';
import { ErrorFallback } from './ErrorFallback';
import { ErrorInfo } from 'react';

interface ErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: React.ComponentType<any>;
  onError?: (error: Error, info: ErrorInfo) => void;
  onReset?: () => void;
}

export function ErrorBoundary({
  children,
  fallback = ErrorFallback,
  onError,
  onReset,
}: ErrorBoundaryProps) {
  const handleError = (error: Error, info: ErrorInfo) => {
    captureException(error, {
      contexts: {
        react: {
          componentStack: info.componentStack,
        },
      },
      tags: {
        errorBoundary: 'true',
      },
    });

    onError?.(error, info);
  };

  const handleReset = () => {
    onReset?.();
  };

  return (
    <ReactErrorBoundary
      FallbackComponent={fallback}
      onError={handleError}
      onReset={handleReset}>
      {children}
    </ReactErrorBoundary>
  );
}
